import clsx from 'clsx';
import ProductItem from 'components/ProductItem';
import ParagraphHeader from 'components/ParagraphHeader';
import { ProductListingModuleProps } from 'interfaces/cms/content';
import LinkComponent from 'components/common/Link';
import ButtonComponent from 'components/common/Button';

function ProductListingModule({
  header,
  productListing,
  seeMoreButton,
}: Readonly<ProductListingModuleProps>) {
  return (
    <div
      className={clsx(
        header?.backgroundType !== 'full' && 'max-w-[69.375rem] mx-auto'
      )}
      style={{
        backgroundColor:
          header?.backgroundType === 'full' ||
          header?.backgroundType === 'block'
            ? header?.backgroundColor
            : 'transparent',
      }}
    >
      <div
        className={clsx(
          'px-[0.9375rem] md:px-[1.25rem] max-w-[69.375rem] pb-[30px] mx-0 my-auto',
          header?.title && 'pt-[1.875rem]'
        )}
      >
        {header && (
          <div className="max-w-[69.375rem] my-0 mx-auto pt-0 pb-[1.875rem] px-0">
            <ParagraphHeader {...header} />
          </div>
        )}

        {productListing && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1.875rem]">
            {productListing.map((item) => (
              <ProductItem key={item.id} isMobileTwoCol={false} {...item} />
            ))}
          </div>
        )}
        {seeMoreButton &&
          (seeMoreButton.buttonPageSlug || seeMoreButton.buttonUrl) && (
            <div
              className={clsx(
                'relative my-[1.875rem] mx-auto rounded-[0.625rem] shadow-[0_0.625rem_0.625rem_rgba(16, 102, 203, 0.10)] w-full',
                'w-full h-[50px] leading-1 p-0'
              )}
            >
              <LinkComponent
                href={
                  seeMoreButton.buttonPageSlug
                    ? seeMoreButton.buttonPageSlug?.slug
                    : seeMoreButton.buttonUrl
                }
                rel={seeMoreButton.buttonLinkRel}
                className="text-center"
                isExternalLink={!!seeMoreButton.buttonUrl}
              >
                <ButtonComponent
                  {...seeMoreButton}
                  buttonType="outline"
                  buttonSize="normal"
                  fontWeight="bold"
                />
              </LinkComponent>
            </div>
          )}
      </div>
    </div>
  );
}

export default ProductListingModule;
